var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"main"},[_c('canvas',{ref:"canvasRef"})])
}
var staticRenderFns = []

export { render, staticRenderFns }